import { getValue } from "@utils/lodash";
import { monthsString } from "./month";
import { toast } from "react-toastify";
import { config } from "../../src/env";
import base64 from "base-64";

export const CopyToClipboard = (value: string) => {
  /* Get the text field */
  //   var copyText = event.currentTarget.firstElementChild.nextElementSibling.value;
  /* Copy the text inside the text field */
  navigator.clipboard.writeText(value);
  /* Alert the copied text */
  // alert("Copied: " + value);
  toast.success(`${value}${" "} copied to clipboard`);
};

export const formatText = (str: string) => {
  const arr = str.split("_");
  const result = [];
  for (const word of arr) {
    result.push(
      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() // 👈️ lowercase remainder
    );
  }
  return result.join(" ");
};

export const formatDecimal = (value: any) => {
  if (value) {
    return value ? parseFloat(value).toFixed(2) : value;
  } else {
    return value;
  }
};

export const textCapitalize = (str: string) => {
  const arr = str.split("_");
  const result = [];
  for (const word of arr) {
    result.push(
      word.toUpperCase() // 👈️ lowercase remainder
    );
  }
  return result.join(" ");
};

export const concatDotToString = (value: any) => {
  if (value) {
    return getValue(value, `length`, 0) > 0
      ? value.substring(0, 100).concat("...")
      : value;
  } else {
    return value;
  }
};

export const concatDotToDocumentString = (value: any) => {
  if (value) {
    return getValue(value, `length`, 0) > 20
      ? value.substring(0, 20).concat("...")
      : value;
  } else {
    return value;
  }
};

export function json2array(json: any) {
  var result: any = [];
  var keys = Object.keys(json);
  keys.forEach(function (key) {
    result.push({
      [key]: json[key],
    });
  });
  return result;
}

export function json2arrayKeyAsMonth(json: any) {
  var result: any = [];
  var keys = Object.keys(json);
  keys.forEach(function (key) {
    result.push({
      [monthsString[parseInt(key) - 1]]: json[key],
    });
  });
  return result;
}

export const concatString = (str: string, length: number) => {
  return str
    ? str.length > length
      ? str.substring(0, length).concat("...")
      : str
    : null;
};

export const numberFormatter = (num: any) => {
  return num.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};

export async function getHmac(message: any, secretKey: any) {
  // Convert the message and secretKey to Uint8Array
  const encoder = new TextEncoder();
  const messageUint8Array = encoder.encode(message);
  const keyUint8Array = encoder.encode(secretKey);

  // Import the secretKey as a CryptoKey
  const cryptoKey = await window.crypto.subtle.importKey(
    "raw",
    keyUint8Array,
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"]
  );

  // Sign the message with HMAC and the CryptoKey
  const signature = await window.crypto.subtle.sign(
    "HMAC",
    cryptoKey,
    messageUint8Array
  );

  // Convert the signature ArrayBuffer to a hex string
  const hashArray = Array.from(new Uint8Array(signature));
  const hashHex = hashArray
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");

  return hashHex;
}

export async function aesGcmEncrypt(plaintext: string) {
  const pwUtf8 = new TextEncoder().encode(config.AUTH_SHARED_KEY); // encode secretKey as UTF-8
  const pwHash = await crypto.subtle.digest("SHA-256", pwUtf8); // hash the secretKey

  const iv = crypto.getRandomValues(new Uint8Array(12)); // get 96-bit random iv
  const ivStr = Array.from(iv)
    .map((b) => String.fromCharCode(b))
    .join(""); // iv as utf-8 string

  const alg = { name: "AES-GCM", iv: iv }; // specify algorithm to use

  const key = await window.crypto.subtle.importKey("raw", pwHash, alg, false, [
    "encrypt",
  ]); // generate key from pw

  const ptUint8 = new TextEncoder().encode(plaintext); // encode plaintext as UTF-8
  const ctBuffer = await window.crypto.subtle.encrypt(alg, key, ptUint8); // encrypt plaintext using key

  const ctArray = Array.from(new Uint8Array(ctBuffer)); // ciphertext as byte array
  const ctStr = ctArray.map((byte) => String.fromCharCode(byte)).join(""); // ciphertext as string
  return btoa(ivStr + ctStr); // iv+ciphertext base64-encoded
}


export const decodeEmail = (mailId: string): string => {
  try {
    
      // if (!mailId) {
      //     console.log('Empty mail id provided');
      //     return '';
      // }
      const decodedEmail = window.atob(mailId);
      return decodedEmail;
  } catch (error) {
      console.error('Error decoding email:', error);
      return '';
  }
};


function isValidURL(url: string) {
  try {
    new URL(url);
    return true;
  } catch (_) {
    return false;
  }
}

export const getEncodedKey = (keyOrUrl: string) => {
  if (isValidURL(keyOrUrl)) {
    return btoa(
      decodeURIComponent(new URL(keyOrUrl).pathname.replace("/", ""))
    );
  } else {
    return btoa(decodeURIComponent(keyOrUrl));
  }
  // return btoa(decodeURIComponent(new URL(url).pathname.replace("/", "")));
};

export function countKeysWithValues(params: any) {
  delete params["is_all_time"];
  delete params["page_no"];
  delete params["search_text"];
  delete params["limit"];
  delete params["from_date"];
  delete params["to_date"];
  delete params["compliance_type_id"];
  delete params["compliance_status"];
  delete params["owner_due_date_from"];
  delete params["owner_due_date_to"];
  delete params["date"];
  if (params.status === "active") {
    delete params["status"];
  }
    // delete params["dashboard_type"];
  // delete params["level"];
  // delete params["status"];
  // delete params["is_user_entity"];
  // delete params["request_from"];
  // delete params["request_value"];
  // delete params ["value"]
  let count = 0;
  for (const key in params) {
    if (
      params.hasOwnProperty(key) &&
      params[key] != null &&
      params[key] !== undefined
    ) {
      count++;
    }
  }
  return count;
}

export const removeNullOrUndefinedProperties = (obj: any) => {
  // return removeNullValues(obj);
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (
        (obj[key] === null ||
          obj[key] === "" ||
          obj[key] === undefined ||
          (Array.isArray(obj[key]) && obj[key].length === 0)) &&
        typeof obj[key] !== "boolean"
      ) {
        delete obj[key];
      }
    }
  }
  return obj;
};

export const snakeToCamelWithSpaces = (str: string) => {
  if (str) {
    return str
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  } else {
    return "";
  }
};

export const convertCamelToSnakeCase = (input: any) => {
  if (input) {
    // Check if the string is in title case
    if (input === input.replace(/\b\w/g, (char: any) => char.toUpperCase())) {
      return input.toUpperCase().replace(/ /g, "_");
    }
    return input;
  } else {
  }
};

export const formatLabelValue = (value: any) => {
  if (value) {
    return value
      .split("_")
      .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  } else {
    return "";
  }
};

export const decodeBase64 = (content: any) => {
  let decodedContent: any;
  try {
    decodedContent = base64.decode(content);
  } catch (error) {
    decodedContent = content; // Fallback to original content if decoding fails
  }
  return decodedContent;
};
